import { toast, Toaster as SonnerToaster } from "sonner";

// Custom Toast component
export const Toaster = () => {
  return (
    <SonnerToaster
      position="top-right"
      duration={4000}
      offset={{ top: 60, right: -20 }}
      toastOptions={{
        style: {
          background: "#757575",
          color: "white",
          border: "none",
          padding: "6px 12px 6px 12px",
          // paddingRight: "40px", // Add extra padding for close button
          borderRadius: "6px",
          boxShadow: "0px 2px 10px 0px #0000004D",
          fontSize: "14px",
          width: "292px",
          position: "relative", // For absolute positioning of close button
        },
        className: "my-custom-toast",
      }}
      closeButton
    />
  );
};

// Success toast with green check icon
export const successToast = (title: string, message: string) => {
  toast.custom((t) => (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center">
          <svg
            width={18}
            height={18}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.83317 12.8337L13.7082 6.95866L12.5415 5.79199L7.83317 10.5003L5.45817 8.12533L4.2915 9.29199L7.83317 12.8337ZM8.99984 17.3337C7.84706 17.3337 6.76373 17.1149 5.74984 16.6774C4.73595 16.2399 3.854 15.6462 3.104 14.8962C2.354 14.1462 1.76025 13.2642 1.32275 12.2503C0.885254 11.2364 0.666504 10.1531 0.666504 9.00033C0.666504 7.84755 0.885254 6.76421 1.32275 5.75033C1.76025 4.73644 2.354 3.85449 3.104 3.10449C3.854 2.35449 4.73595 1.76074 5.74984 1.32324C6.76373 0.885742 7.84706 0.666992 8.99984 0.666992C10.1526 0.666992 11.2359 0.885742 12.2498 1.32324C13.2637 1.76074 14.1457 2.35449 14.8957 3.10449C15.6457 3.85449 16.2394 4.73644 16.6769 5.75033C17.1144 6.76421 17.3332 7.84755 17.3332 9.00033C17.3332 10.1531 17.1144 11.2364 16.6769 12.2503C16.2394 13.2642 15.6457 14.1462 14.8957 14.8962C14.1457 15.6462 13.2637 16.2399 12.2498 16.6774C11.2359 17.1149 10.1526 17.3337 8.99984 17.3337Z"
              fill="#6FFF98"
            />
          </svg>
        </div>
        <div>
          <div className="font-semibold text-white">{title}</div>
          <div className="text-white opacity-90 text-sm">{message}</div>
        </div>
      </div>
      <div
        className="rounded-full flex items-center justify-end cursor-pointer"
        onClick={() => toast.dismiss(t)}
      >
        <svg
          width={18}
          height={18}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_739_20546"
            style={{
              maskType: "alpha",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={18}
            height={18}
          >
            <rect width={18} height={18} fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_739_20546)">
            <path
              d="M4.8 14.25L3.75 13.2L7.95 9L3.75 4.8L4.8 3.75L9 7.95L13.2 3.75L14.25 4.8L10.05 9L14.25 13.2L13.2 14.25L9 10.05L4.8 14.25Z"
              fill="#FCFCFC"
            />
          </g>
        </svg>
      </div>
    </div>
  ));
};

// Error toast with red cross icon
export const errorToast = (title: string, message: string) => {
  toast.custom((t) => (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center">
        <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center">
          <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_739_20364"
              style={{
                maskType: "alpha",
              }}
              maskUnits="userSpaceOnUse"
              x={0}
              y={0}
              width={20}
              height={20}
            >
              <rect width={20} height={20} fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_739_20364)">
              <path
                d="M6.875 17.5L2.5 13.125V6.875L6.875 2.5H13.125L17.5 6.875V13.125L13.125 17.5H6.875ZM7.625 13.5417L10 11.1667L12.375 13.5417L13.5417 12.375L11.1667 10L13.5417 7.625L12.375 6.45833L10 8.83333L7.625 6.45833L6.45833 7.625L8.83333 10L6.45833 12.375L7.625 13.5417Z"
                fill="#FF6F6F"
              />
            </g>
          </svg>
        </div>
        <div>
          <div className="font-semibold text-white">{title}</div>
          <div className="text-white opacity-90 text-sm">{message}</div>
        </div>
      </div>
      <div
        className="rounded-full flex items-center justify-end cursor-pointer"
        onClick={() => toast.dismiss(t)}
      >
        <svg
          width={18}
          height={18}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_739_20546"
            style={{
              maskType: "alpha",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={18}
            height={18}
          >
            <rect width={18} height={18} fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_739_20546)">
            <path
              d="M4.8 14.25L3.75 13.2L7.95 9L3.75 4.8L4.8 3.75L9 7.95L13.2 3.75L14.25 4.8L10.05 9L14.25 13.2L13.2 14.25L9 10.05L4.8 14.25Z"
              fill="#FCFCFC"
            />
          </g>
        </svg>
      </div>
    </div>
  ));
};
